import SearchQueryBase from "./search-query-base.class";

export class KeywordQuery extends SearchQueryBase {
	constructor() {
		super();
	}

	setKeyWord(keyWord: string | null): void {
		this.queryData["keyword"] = keyWord;
		this.resetPage();
	}
}
